"use client";
import { useConfig } from "@stadium/hooks/lib/use-config";

import { getBookACallCtaText } from "@stadium/shared/src/selectors/book-a-call";
import { useCallback } from "react";

export const useBookACallText = ({ defaultText = "TALK TO SALES" }) => {
    const selectorToGetText = useCallback((storeState) => getBookACallCtaText(storeState, defaultText), [defaultText]);
    const bookACallCtaText = useConfig(selectorToGetText);
    return bookACallCtaText;
};